import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {convertSecondsToMMSSFormat} from '@Utils/date.util';
import {CurrentTimeText} from '@Components/poster-editor/components/poster-seekbar/components/current-time-text';
import {getCurrentPageDuration, getPosterDuration} from '@Components/poster-editor/poster-editor-reducer';
import {onPosterPause, onPosterPlay} from '@Components/poster-editor/library/poster-editor-library';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {PlayPauseButton} from '@Components/media-control-buttons/components/play-pause-button';
import {useAppSelector} from '@/hooks';
import styles from './poster-mobile-small-seekbar.module.scss';

export function PosterMobileSmallSeekbar(): ReactElement | null {
  const currentPageDuration = useAppSelector(getCurrentPageDuration);
  const isPlaying = useAppSelector((state) => {
    return state.posterEditor.isPlaying;
  });
  const currentTime = useAppSelector((state) => {
    return state.posterEditor.currentTime;
  });
  const posterDuration = useAppSelector(getPosterDuration);

  const getTotalTime = (): ReactElement => {
    return <Text val={convertSecondsToMMSSFormat(currentPageDuration)} size={TextSize.XXSMALL} />;
  };

  const getCurrentTime = (): ReactElement => {
    return <CurrentTimeText />;
  };

  return (
    <div className={`${styles.seekbar} radius-round border-s-standard  flexbox spacing-p-2`}>
      <PlayPauseButton
        className="spacing-p-2"
        isPlaying={isPlaying}
        onPlay={(): void => {
          onPosterPlay();
        }}
        onPause={(): void => {
          onPosterPause();
        }}
        iconShape={IconShape.CIRCLE}
        iconType={IconType.GHOST}
        iconSize={IconSize.SIZE_ICON_24}
        totalDuration={posterDuration}
        currentTime={currentTime}
      />
      <div className="flex-center spacing-m-r-3 spacing-m-l-2">
        {getCurrentTime()}
        {getTotalTime()}
      </div>
    </div>
  );
}
